import { createContext, useContext, useState, useEffect } from 'react';

const PreferenceContext = createContext(null);

const STORAGE_KEY = 'tossit_preferences';

const loadPrefs = () => {
    try {
        const saved = localStorage.getItem(STORAGE_KEY);
        return saved ? JSON.parse(saved) : {};
    } catch {
        return {};
    }
};

// Central store for lightweight personalization flags (e.g. veg-only).
// Persisted + hydrated so a vegetarian user never has to re-toggle on each visit.
export const PreferenceProvider = ({ children }) => {
    const [prefs, setPrefs] = useState(() => ({ vegOnly: false, ...loadPrefs() }));

    useEffect(() => {
        try {
            localStorage.setItem(STORAGE_KEY, JSON.stringify(prefs));
        } catch { /* storage full / unavailable — ignore */ }
    }, [prefs]);

    const setVegOnly = (value) => {
        setPrefs(prev => ({ ...prev, vegOnly: typeof value === 'function' ? value(prev.vegOnly) : value }));
    };

    return (
        <PreferenceContext.Provider value={{ vegOnly: prefs.vegOnly, setVegOnly }}>
            {children}
        </PreferenceContext.Provider>
    );
};

export const usePreferences = () => {
    const context = useContext(PreferenceContext);
    if (!context) throw new Error('usePreferences must be used within a PreferenceProvider');
    return context;
};
